export default __webpack_public_path__ + "car_service.50e59c31b000a997ed47952750bcf520.webp";